import { track } from '@src/services/analytics';

export const trackUpsellModalShown = (productId: string, sellerId: string, upsellCandidatesCount: number) =>
  track('upsell_modal_shown', {
    product_id: productId,
    seller_id: sellerId,
    upsell_candidates_count: upsellCandidatesCount,
  });

// PR-4286: the PRD's RNF-01 table also lists `is_p3p`, but no P3P concept exists anywhere in
// the backend (confirmed: `grep -rniE p3p core` returns nothing) — only "produto de parceria"
// exists, a different concept. Intentionally omitted rather than sent as an always-empty field.
export const trackUpsellProductSelected = (productId: string, upsellProductId: string, upsellProductSellerId: string) =>
  track('upsell_product_selected', {
    product_id: productId,
    upsell_product_id: upsellProductId,
    upsell_product_seller_id: upsellProductSellerId,
  });

export const trackUpsellContinued = (productId: string, selectedCount: number, totalCandidatesShown: number) =>
  track('upsell_continued', {
    product_id: productId,
    selected_count: selectedCount,
    total_candidates_shown: totalCandidatesShown,
  });

export const trackUpsellSkipped = (productId: string, timeOnModalMs: number) =>
  track('upsell_skipped', { product_id: productId, time_on_modal_ms: timeOnModalMs });

export const trackUpsellBookingStarted = (productId: string, upsellProductId: string, sequenceIndex: number) =>
  track('upsell_booking_started', {
    product_id: productId,
    upsell_product_id: upsellProductId,
    sequence_index: sequenceIndex,
  });

export const trackUpsellBookingCompleted = (productId: string, upsellProductId: string, bookingTotalCents: number) =>
  track('upsell_booking_completed', {
    product_id: productId,
    upsell_product_id: upsellProductId,
    booking_total_cents: bookingTotalCents,
  });

export const trackUpsellBookingAbandoned = (
  productId: string,
  upsellProductId: string | undefined,
  lastStepReached: string | undefined,
) =>
  track('upsell_booking_abandoned', {
    product_id: productId,
    upsell_product_id: upsellProductId,
    last_step_reached: lastStepReached,
  });

export const trackUpsellCompleted = (productId: string, itemsAdded: number, upsellTotalCents: number) =>
  track('upsell_completed', {
    product_id: productId,
    items_added: itemsAdded,
    upsell_total_cents: upsellTotalCents,
  });
